import React, { useEffect, useState } from "react";
import "./header.css";
import { Turn as Hamburger } from "hamburger-react";
import logo from "../assets/clients/headerpng.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { IoMdCall } from "react-icons/io";

const Header = () => {
  const [isOpen, setOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const user = useSelector((data) => data.auth.user);
  const location = useLocation();
  const [activeLink, setActiveLink] = useState("/");

  useEffect(() => {
    setActiveLink(location.pathname);
  }, [location.pathname]);

  const handleNavLinkClick = (path) => {
    setActiveLink(path);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    if (isMobile) {
      setOpen(false);
    }
  };
  const navigate = useNavigate();
  const handleSubscriptionClick = () => {
    navigate("/subscription");
  };

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleNav = () => {
    if (isMobile) {
      setOpen((prev) => !prev);
    }
  };

  const handleLinkClick = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    if (isMobile) {
      setOpen(false);
    }
  };

  return (
    <div className="header">
      <Link to="/">
        <img
          src={logo}
          alt="bhookr-logo"
          className="logo"
          loading="lazy"
          id="logo"
        />
      </Link>
      <nav className={isOpen ? "Mobilenav" : "nav"}>
        <h3 className="pages">pages</h3>
        <Link
          to="/"
          onClick={() => handleNavLinkClick("/")}
          className={`navlinlk ${activeLink === "/" ? "active" : ""}`}
        >
          Home
        </Link>
        <Link
          to="/menu"
          onClick={() => handleNavLinkClick("/menu")}
          className={`navlinlk ${activeLink === "/menu" ? "active" : ""}`}
        >
          Menu
        </Link>
        <Link
          to="/about"
          onClick={() => handleNavLinkClick("/about")}
          className={`navlinlk ${activeLink === "/about" ? "active" : ""}`}
        >
          About
        </Link>
        <Link
          to="/contact"
          onClick={() => handleNavLinkClick("/contact")}
          className={`navlinlk ${activeLink === "/contact" ? "active" : ""}`}
        >
          Contact
        </Link>
        {/* <Link to="/form" onClick={handleLinkClick} className=" navlinlk">
          Form
        </Link> */}
        <Link
          to="/subscription"
          onClick={() => handleNavLinkClick("/subscription")}
          className={`navlinlk ${
            activeLink === "/subscription" ? "active" : ""
          }`}
        >
          Subscription
        </Link>
        <Link
          to="/howitworks"
          onClick={() => handleNavLinkClick("/howitworks")}
          className={`navlinlk ${activeLink === "/howitworks" ? "active" : ""}`}
        >
          How It Works
        </Link>

        {/* <div className="profile">
          <h3>Acoount</h3>
          <div>
            <p className="text-[white]">{user ? "My Profile" : ""}</p>
            <p className="text-[white]">{user ? "Sign Out" : "Sign In"}</p>
          </div>
        </div> */}
        <div className="my-account">
          <h3>Contact us</h3>
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#131313"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-phone-incoming"
            >
              <polyline points="16 2 16 8 22 8" />
              <line x1="22" x2="16" y1="2" y2="8" />
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
            </svg>
            <a href="tel:9542762906">+91 9542762906</a>
          </div>
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#131313"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-mail"
            >
              <rect width="20" height="16" x="2" y="4" rx="2" />
              <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
            </svg>
            <a href="mailto:bhookr555@gmail.com">bhookr555@gmail.com</a>
          </div>
        </div>
      </nav>
      <div className="burgermenu">
        {isMobile ? (
          <Hamburger toggled={isOpen} toggle={toggleNav} color="#131313" />
        ) : (
          <button
            className="callheader"
            onClick={() => handleSubscriptionClick()}
          >
            <span>Subscribe Now</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default Header;
